import $ from 'jquery';
export default {
	init() {
		// Hero Hover Animations
		$('.ai-block-hero .link').on('mouseover', function () {
			$('.page-title').addClass('hover');
		});
		$('.ai-block-hero .link').on('mouseleave', function () {
			$('.page-title').removeClass('hover');
		});

		// Pagination and some Multi-Filter Javascript lives in common.js
		function filter() {
			// Remove filter items and load based on checked .option items
			$('.filter-item').remove();
			$('.option.checked').each(function () {
				$('.news-filter-items').append(
					'<li class="filter-item" data-value="' +
						$(this).attr('data-value') +
						'">' +
						$(this).text() +
						'</li>'
				);
			});
			// Remove all news, pagination, and post count
			$('#ajax-posts>*').remove();
			$('#pagination>*').remove();
			$('#news-count-number>*').remove();
			var $query = [],
				$filterurl = '/news/';
			// Build filter url for AJAX call
			if ($('.option.checked').length) {
				if ($('#portfolio-filter .option.checked').length) {
					var $portfolioparams = 'portfolio-company=';
					$.each(
						$('#portfolio-filter .option.checked'),
						function (index, value) {
							if (index > 0) {
								$portfolioparams += ',';
							}
							$portfolioparams += $(this).attr('data-value');
						}
					);
					$query.push($portfolioparams);
				}
				if ($('#type-filter .option.checked').length) {
					var $typeparams = 'news-type=';
					$.each($('#type-filter .option.checked'), function (index, value) {
						if (index > 0) {
							$typeparams += ',';
						}
						$typeparams += $(this).attr('data-value');
					});
					$query.push($typeparams);
				}
				if ($('#year-filter .option.checked').length) {
					var $yearparams =
						'yr=' + $('#year-filter .option.checked').attr('data-value');
					$query.push($yearparams);
				}
				if ($('#month-filter .option.checked').length) {
					var $monthparams = 'mth=';
					$.each($('#month-filter .option.checked'), function (index, value) {
						if (index > 0) {
							$monthparams += ',';
						}
						$monthparams += $(this).attr('data-value');
					});
					$query.push($monthparams);
				}
				$query = $query.join('&', $query);
				if ($query.length) {
					$filterurl = $filterurl + '?' + $query;
				}
			}
			// AJAX calls to pull in news, pagination, and post count
			$('#news-count-number').load($filterurl + ' #news-count-number>*');
			$('#ajax-posts').load($filterurl + ' #ajax-posts>*', function () {
				// Trigger animate() function in common.js
				window.scrollTo(window.scrollX, window.scrollY - 1);
				window.scrollTo(window.scrollX, window.scrollY + 1);
			});
			$('#pagination').load($filterurl + ' #pagination>*');
		}
		// Filter when multi-filter .option item is clicked
		$('.option').click(function () {
			filter();
		});
		// Filter when .filter-item item is clicked after removing this item and updating checked .option items
		$('.news-filter-items').click('.filter-item', function (e) {
			if ($(e.target).hasClass('filter-item')) {
				$(e.target).remove();
				$(
					'.option[data-value="' + $(e.target).attr('data-value') + '"]'
				).removeClass('checked');
				filter();
			}
		});
	},
	finalize() {},
};
